<template>
  <div>
    <h5 v-if="label" class="text-subhead-4 mx-4 mb-[2px] text-left text-black-80" :for="name">{{ label }}</h5>
    <UIBaseTransition>
      <div v-if="loading" class="flex h-10 items-center text-black-80">
        <UIProgressSpinner color="current" class="ml-4" />
      </div>
      <div v-else class="flex flex-row flex-wrap gap-1">
        <div
          v-for="item in items"
          :key="item.value"
          :class="[
            errors.length
              ? 'border border-solid border-error-100'
              : getIsItemActive(item)
              ? 'border border-solid !border-gold-primary-100 bg-gold-primary-100'
              : 'border border-solid border-black-20 bg-white text-black-80',

            'text-body-3 h-10 flex-auto cursor-pointer select-none truncate rounded-xl border-base px-2.5 py-2 text-center transition-all duration-300 ease-in-out hover:border-black-80',
          ]"
          @click="selectOption(item[props.valueKey])"
        >
          {{ item[props.labelKey] }}
        </div>
      </div>
    </UIBaseTransition>
    <div v-if="errorMessage?.trim()" class="mt-1 text-left text-error-100">{{ $t(errorMessage) }}</div>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'
import isArray from 'lodash/isArray'

const modelValue = defineModel<number | number[] | undefined>({ required: true })

type Props = {
  value: undefined
  items: any[]
  name: string
  label?: string
  placeholder?: string
  disabled?: boolean
  error?: string
  multiple?: boolean
  loading?: boolean
  labelKey?: string
  valueKey?: string
  controlled?: boolean
  syncVModel?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  value: undefined,
  items: () => [],
  name: '',
  label: '',
  placeholder: '',
  disabled: false,
  error: '',
  multiple: false,
  labelKey: 'text',
  valueKey: 'value',
})

const name = toRef(props, 'name')

const { errorMessage, handleChange, errors } = useField(name, undefined, {
  initialValue: modelValue.value || props.value,
  controlled: props.controlled,
  syncVModel: props.syncVModel,
})

const getIsItemActive = (item: any) => {
  if (props.multiple && isArray(modelValue.value)) {
    return modelValue.value.includes(item[props.valueKey])
  }

  return modelValue.value === item[props.valueKey]
}

const selectOption = (value: any) => {
  if (props.multiple && isArray(modelValue.value)) {
    const index = modelValue.value.indexOf(value)

    if (index === -1) {
      modelValue.value.push(value)
    } else {
      modelValue.value.splice(index, 1)
    }
  } else {
    modelValue.value = modelValue.value === value ? undefined : value
  }
  handleChange(modelValue.value)
}
</script>

<style scoped></style>
